import React from 'react';
import classNames from 'classnames';
import { Field } from 'react-final-form';
import { RadioButton } from '../../components';

import css from './FieldRadioButton.css';

const FieldRadioButtonComponent = props => {
  const { rootClassName, className, svgClassName, textClassName,  id, label = null, showAsRequired, size = 'small', radioClassName, ...rest } = props;
  const classes = classNames(rootClassName || css.root, className);
  const classesRadio = classNames(radioClassName, css.radio)
  const radioButtonProps = {
    id,
    className: css.input,
    component: 'input',
    type: 'radio',
    ...rest,
  };

  return (
    <span className={classes}>
      <Field {...radioButtonProps}>
        {({ input }) => (
          <RadioButton  
            label={label}
            size={size}
            {...input}
            textClassName={classNames(css.text, textClassName)}
            radioClassName={classesRadio}
          />
        )}
      </Field>
    </span>
  );
};

export default FieldRadioButtonComponent;
